import withStore, {
  TPresentable,
  TLoadingAwarePresenter
} from "../../core/presenter/withStore";
import Application from "../../Application";
import { IUser } from "../../user/model/User";
import { IOrganisation } from "../../organisations/model/Organisation";
import GetIndexHarmonizationReportInteractor from "../interactor/GetIndexHarmonizationReportInteractor";
import { IIndexHarmonizationReportItem } from "../model/IndexHarmonizationReportItem";
import moment from "moment";
import { IIndexTypeCategory } from "../../indexTypes/model/IndexTypeCategory";
import GetAllIndexTypeCategoriesInteractor from "../../indexTypes/interactors/GetAllIndexTypeCategoriesInteractor";

export interface TCaseLawDocumentsByDateReportPresenter
  extends TLoadingAwarePresenter {
  user?: IUser;
  organisationIds?: number[];
  organisations: IOrganisation[];
  indexCategories: IIndexTypeCategory[];
  dateIncluded?: Date;
  selectedCategoryId: number;
  data: IIndexHarmonizationReportItem[];
  fromDate?: Date;
  toDate?: Date;
}

export interface ICaseLawDocumentsByDateReportPresenter
  extends TCaseLawDocumentsByDateReportPresenter,
    TPresentable {
  loadReferenceValues(organisations: IOrganisation[]): void;
  setDateIncluded(dateIncluded: Date): void;
  setOrganisationIds(organisationId: number[]): void;
  setCategoryId(categoryId: number): void;
  getData(): void;
  onChangeDateRange(fromDate: Date, toDate: Date): void;
}

const defaultState: TCaseLawDocumentsByDateReportPresenter = {
  selectedCategoryId: NaN,
  organisations: [],
  indexCategories: [],
  dateIncluded: undefined,
  data: [],
  toDate: new Date(),
  fromDate: moment().subtract(1, "months").toDate()
};

const CaseLawDocumentsByDateReportPresenter = withStore<
  ICaseLawDocumentsByDateReportPresenter,
  TCaseLawDocumentsByDateReportPresenter
>(
  ({
    application,
    store,
    loader,
    translate
  }): ICaseLawDocumentsByDateReportPresenter => {
    const _store = store;
    const _application: Application = application;
    const state = _store.getState<
      TCaseLawDocumentsByDateReportPresenter & TLoadingAwarePresenter
    >();
    loader.start("projectLoader");
    const loadReferenceValues = (organisations: IOrganisation[]) => {
      const user = _store.getState<any>().user;
      _store.update({ organisations, user });
      getIndexCategories();
      loader.stop("projectLoader");
      loader.stop("reportLoader");
    };

    const getIndexCategories = async () => {
      let data = await _application.container
        .resolve<GetAllIndexTypeCategoriesInteractor>(
          "getAllIndexTypeCategories"
        )
        .execute();
      _store.update({
        indexCategories: data,
        selectedCategoryId: undefined,
        data: undefined
      });
    };
    const setDateIncluded = (dateIncluded: Date) => {
      _store.update({ dateIncluded, data: undefined });
    };
    const setCategoryId = (categoryId: number) => {
      _store.update({ selectedCategoryId: categoryId, data: undefined });
    };
    const setOrganisationIds = (organisationIds: number[]) => {
      _store.update({ organisationIds, data: undefined });
    };
    const getData = async () => {
      const { selectedCategoryId } =
        _store.getState<TCaseLawDocumentsByDateReportPresenter>();
      loader.start("reportLoader");
      let data = await _application.container
        .resolve<GetIndexHarmonizationReportInteractor>(
          "getIndexHarmonizationReport"
        )
        .execute(selectedCategoryId);
      _store.update({ data });
      loader.stop("reportLoader");
    };

    const onChangeDateRange = (fromDate: Date, toDate: Date) => {
      _store.update({
        fromDate,
        toDate
      });
    };
    return {
      ...state,
      store: _store,
      loader,
      application: _application,
      translate,
      loadReferenceValues,
      setDateIncluded,
      setOrganisationIds,
      getData,
      setCategoryId,
      onChangeDateRange
    };
  },
  defaultState
);

export default CaseLawDocumentsByDateReportPresenter;
